var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup31(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-156.067 -1290.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M202.181,1305.17a24.077,24.077,0,1,0,1.886,9.342A23.922,23.922,0,0,0,202.181,1305.17ZM201.1,1323.4a22.9,22.9,0,1,1,1.794-8.885A22.751,22.751,0,0,1,201.1,1323.4Z",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M302.662,1384.321a.587.587,0,0,0,0-1.174h-4.625a2.993,2.993,0,0,0-2.34-2.339v-7.842a.587.587,0,0,0-1.174,0v7.842a2.985,2.985,0,1,0,3.514,3.514Zm-7.551,1.224a1.811,1.811,0,1,1,1.811-1.811A1.813,1.813,0,0,1,295.111,1385.545Z",
    transform: "translate(-115.044 -69.222)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M308.237,1325.67a.587.587,0,0,0,.587-.587v-2.74a.587.587,0,1,0-1.174,0v2.74A.587.587,0,0,0,308.237,1325.67Z",
    transform: "translate(-128.17 -26.417)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M308.237,1544.694a.587.587,0,0,0-.587.587v2.74a.587.587,0,0,0,1.174,0v-2.74A.587.587,0,0,0,308.237,1544.694Z",
    transform: "translate(-128.17 -214.922)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M413.576,1442.095h-2.74a.587.587,0,0,0,0,1.174h2.74a.587.587,0,0,0,0-1.174Z",
    transform: "translate(-214.921 -128.17)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M191.224,1442.682a.587.587,0,0,0-.587-.587H187.9a.587.587,0,0,0,0,1.174h2.74A.587.587,0,0,0,191.224,1442.682Z",
    transform: "translate(-26.416 -128.17)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M399.687,1494.964l-2.371-1.373a.587.587,0,1,0-.588,1.016l2.371,1.373a.587.587,0,1,0,.588-1.016Z",
    transform: "translate(-203.241 -171.645)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M206.764,1383.239l-2.371-1.373a.587.587,0,1,0-.588,1.016l2.371,1.373a.587.587,0,1,0,.588-1.016Z",
    transform: "translate(-40.116 -77.177)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M360.566,1530.934a.587.587,0,0,0-1.013.593l1.384,2.365a.587.587,0,1,0,1.013-.593Z",
    transform: "translate(-171.988 -203.041)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M248.837,1341.773a.587.587,0,0,0,.506-.884l-1.384-2.365a.587.587,0,1,0-1.013.593l1.384,2.365A.587.587,0,0,0,248.837,1341.773Z",
    transform: "translate(-76.773 -40.351)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M249.721,1531.021a.587.587,0,0,0-.8.215l-1.37,2.373a.587.587,0,1,0,1.017.587l1.37-2.373A.587.587,0,0,0,249.721,1531.021Z",
    transform: "translate(-77.285 -203.295)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M359.251,1341.351a.587.587,0,0,0,.8-.215l1.37-2.373a.587.587,0,1,0-1.017-.587l-1.37,2.373A.587.587,0,0,0,359.251,1341.351Z",
    transform: "translate(-171.552 -40.053)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M205.882,1493.141,203.5,1494.5a.587.587,0,1,0,.583,1.019l2.378-1.361a.587.587,0,0,0-.583-1.019Z",
    transform: "translate(-39.86 -171.266)",
    fill: "#073448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M397.28,1384.848a.583.583,0,0,0,.291-.078l2.378-1.361a.587.587,0,0,0-.583-1.019l-2.378,1.361a.587.587,0,0,0,.292,1.1Z",
    transform: "translate(-203.459 -77.621)",
    fill: "#073448"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup31);
export default __webpack_public_path__ + "static/media/Group 31.25af989b36e1c4a5a0dd502358ae5218.svg";
export { ForwardRef as ReactComponent };